import { getPublicOfEntity } from "services/general";
import { EVENTS_CONSTANTS } from "config/constants";

const { EVENT_PERIOD_IDS } = EVENTS_CONSTANTS;

const parseToEventForm = data => {
	const {
		titulo,
		descripcion,
		destacar,
		idGraficaEvento,
		idAreaServicioPorTipoEvento,
		diaUnico,
		variosDias,
		idOrganizador,
		codigoDocente,
		docente,
		vacantes,
		estudiantesGeneral,
		idUbicacion,
		idEventoInscripcion,
		ambienteFueraCampus,
		idAmbiente,
		piso,
		estudiantesArchivo,
		enlaceDoc,
		idTipoZoom,
		categoriaSalarial,
		idCampusOrganizador,
		linkInformacion,
		linkInformacionDesc,
		seccionExtracurricularId,
		fechaMaximaListaEspera
	} = data;
	return {
		title: titulo,
		description: descripcion,
		standOutEvent: destacar,
		eventGraphicId: idGraficaEvento,
		complementaryServiceAreaId: idAreaServicioPorTipoEvento,
		onlyDay: diaUnico
			? {
					date: diaUnico.fecha,
					timeStart: diaUnico.horaInicio,
					timeEnd: diaUnico.horaFin,
			  }
			: null,
		manyDays: variosDias
			? {
					dateStart: variosDias.fechaInicio,
					dateEnd: variosDias.fechaFin,
					waitlist: fechaMaximaListaEspera,
					time: variosDias.horario.map(
						({ idDia, horaInicio, horaFin }) => ({
							dayId: idDia,
							start: horaInicio,
							end: horaFin,
						})
					),
			  }
			: null,
		organizerId: idOrganizador,
		teacherCode: codigoDocente,
		teacher: docente
			? {
					fullName: docente.nombre,
					accountId: docente.idCuenta,
			  }
			: null,
		locationId: idUbicacion,
		zoomInscriptionTypeId: idEventoInscripcion,
		environmentOutCampus: ambienteFueraCampus
			? {
					campusId: ambienteFueraCampus.idCampus,
					internalOrExternal: ambienteFueraCampus.nombre,
					address: ambienteFueraCampus.direccion,
			  }
			: null,
		environmentId: idAmbiente,
		floor: piso,
		zoomLink: enlaceDoc,
		zoomTypeId: idTipoZoom,
		payGradeId: categoriaSalarial,
		quantityVacancy: vacantes,
		generalStudents: estudiantesGeneral
			? {
					publicByCampusIds: estudiantesGeneral.campusIds,
					modalityId: estudiantesGeneral.idModalidad,
			  }
			: null,
		fileStudentsName: estudiantesArchivo ? estudiantesArchivo.nombre : null,
		placeOrganization: {
			campus: {
				id: idCampusOrganizador,
				
			},
		},
		linkInformacion: linkInformacion,
		linkInformacionDesc: linkInformacionDesc,
		sectionSubtype: seccionExtracurricularId
	};
};
export const toEventItem = ({
	idEvento: id,
	titulo: title,
	destacar: standOutEvent,
	duracion,
	duracionHoras: time,
	nombreDocente: teacher,
	ubicacion,
	idEventoCulturalFecha: dateEventId,
	hoy: today,
	puedeTomarAsistencia: canTakeAttendance,
	fechaCreacionOEditado: creationOrUpdatedDate,
	inscritos: enrolled,
	estadoPS: state,
}) => {
	return {
		id,
		title,
		standOutEvent,
		duration: {
			onlyDay: duracion.diaUnico
				? {
						date: duracion.diaUnico.fecha,
				  }
				: null,
			manyDays: duracion.variosDias
				? {
						days: duracion.variosDias.diaEV.map(
							({ nombre, tomado }) => {
								return {
									name: nombre,
									taken: tomado,
								};
							}
						),
						date: duracion.variosDias.fecha,
				  }
				: null,
		},
		time,
		teacher,
		canTakeAttendance,
		location: ubicacion
			? {
					zoom: ubicacion.zoom
						? {
								name: ubicacion.zoom.nombre,
								link: ubicacion.zoom.link,
						  }
						: null,
					place: ubicacion.lugar
						? {
								campus: ubicacion.lugar.nombre,
								address: ubicacion.lugar.direccion,
						  }
						: null,
			  }
			: null,
		today,
		enrolled,
		creationOrUpdatedDate,
		dateEventId,
		state
	};
};
const getBodyToAddOrUpdateRequestStep1 = (
	form,
	ignoreDurationFields = {
		onlyDay: false,
		manyDays: false,
	}
) => {
	const { title, description, standOutEvent, linkInformacionDesc, linkInformacion  } = form.part1;
	const { eventGraphicId, complementaryServiceAreaId, sectionSubtype,eventSubtypeId  } = form.part2;
	const { period, duration } = form.part3;
	const isCulturalOrSport = eventSubtypeId == EVENTS_CONSTANTS.EVENT_SUBTYPES.CULTURAL || eventSubtypeId == EVENTS_CONSTANTS.EVENT_SUBTYPES.SPORT
	let body = {
		titulo: title.trim(),
		descripcion: description.trim(),
		destacar: standOutEvent,
		idGraficaEvento: eventGraphicId,
		idAreaServicioPorTipoEvento: complementaryServiceAreaId,
		linkInformacion: linkInformacion,
		linkInformacionDesc: linkInformacionDesc,
		seccionExtracurricularId: sectionSubtype > 0 ? sectionSubtype : null,
	};
	// Setteando valores cuando el período es día único
	if (period === EVENT_PERIOD_IDS.ONLY_DAY && !ignoreDurationFields.onlyDay) {
		const { date, time } = duration.onlyDay;
		body = {
			...body,
			diaUnico: {
				fecha: date,
				horaInicio: time.start,
				horaFin: time.end,
			},
		};
	}
	// Setteando valores cuando el período es varios días
	else if (
		period === EVENT_PERIOD_IDS.MANY_DAYS &&
		!ignoreDurationFields.manyDays
	) {
		const { date, time } = duration.manyDays;
		body = {
			...body,
			variosDias: {
				fechaInicio: date.start,
				fechaFin: date.end,
				horario: time.map(({ dayId, start, end }) => {
					return {
						idDia: dayId,
						inicio: start,
						fin: end,
					};
				}),
			},
			fechaMaximaListaEspera: (date.waitlist > 0 && isCulturalOrSport) ? date.waitlist : null
		};
	}
	return body;
};
export const getBodyToUpdateRequestStep2 = form => {
	const { organizerId, teacher, payGradeId, placeOrganization } = form.part1;
	const { locationId, zoomTypeId, zoomInscriptionTypeId, place } = form.part2;
	const { quantityVacancy, publicLoad } = form.part3;
	let body = {
		idOrganizador: organizerId,
		idUbicacion: locationId,
		vacantes: parseInt(quantityVacancy),
		categoriaSalarial: payGradeId || null,
		idCampusOrganizador: placeOrganization.campus.id,
	};
	// Setteando atributos cuando el ponente es un docente de la universidad
	if (!teacher.search.id) {
		const { free } = teacher;
		body = {
			...body,
			docente: {
				nombre: free.fullName.trim(),
			},
		};
		if (free.accountId > 0)
			body = {
				...body,
				docente: {
					...body.docente,
					idCuenta: free.accountId,
				},
			};
	}
	// Setteando atributos cuando el ponente es externo
	else {
		const { id } = teacher.search;
		body = {
			...body,
			codigoDocente: id,
		};
	}
	// Setteando campos cuando la ubicación es zoom
	if (locationId === 1) {
		body = {
			...body,
			idEventoInscripcion: zoomInscriptionTypeId,
			idTipoZoom: zoomTypeId,
		};
	}
	// Setteando campos cuando la ubicación es lugar
	else if (locationId === 2) {
		const { campus, environment } = place;
		const { inCampus, outCampus } = environment;
		if (inCampus.id > 0) {
			body = {
				...body,
				idCampus: campus.id,
				idAmbiente: inCampus.id,
				piso: inCampus.floor.trim(),
			};
		} else {
			const { internalOrExternal, address } = outCampus;
			body = {
				...body,
				ambienteFueraCampus: {
					idCampus: campus.id,
					nombre: internalOrExternal.trim(),
					direccion: address.trim(),
				},
			};
		}
	}
	return {
		...body,
		...getPublicOfEntity(publicLoad),
	};
};
export const toEventReportItem = ({
	idLista,
	idEvento,
	codigoAlumno,
	fechaRegistro,
	fechaInscripcion,
	fechaNotificacion,
	periodo,
	idEstado,
	descripcionEstado,
	descripcionCorta,
	nombreEvento,
	fecha,
	fechaInicio,
	fechaFin
}) => {
	return {
		idLista,
		idEvento,
		codigoAlumno,
		fechaRegistro,
		fechaInscripcion,
		fechaNotificacion,
		periodo,
		idEstado,
		descripcionEstado,
		descripcionCorta,
		nombreEvento,
		fecha,
		fechaInicio,
		fechaFin		
	};
};

const helpers = {
	getBodyToAddOrUpdateRequestStep1,
	parseToEventForm,
	toEventReportItem
};
export default helpers;
